module.exports = require("unist-util-remove-position");


//////////////////
// WEBPACK FOOTER
// external "unist-util-remove-position"
// module id = 42
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13